import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'

import appReducer from './modules/reducer';

const rootReducer = combineReducers({
    appReducer: appReducer,
});

export default function generateStore() {
    const store = createStore(rootReducer, applyMiddleware(thunk));
    return store;
}
